export function resolveAiEmployeeConsoleSubPath(hostPath: string, defaultPath = '/settings', prefix = '/crae-ai-employee') {
  if (hostPath !== prefix && !hostPath.startsWith(`${prefix}/`)) {
    return undefined
  }
  const path = hostPath.slice(prefix.length)
  if (!path || path === '/') {
    return defaultPath
  }
  return path === '/balance' ? '/payroll-bills' : path
}
